// Only this fixed same-origin route may take precedence over the normal
// post-login dashboard. Never honor an arbitrary redirect supplied by a link.
export function campaignRemovalRedirect(pending: string | null): string | null {
    return pending && /^\/client\/pet\/remove\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pending)
        ? pending : null;
}
